import React from 'react';
import { reduxForm, Field, formValueSelector, FieldArray } from 'redux-form';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import cx from 'classnames';
import { compose } from 'redux';
import Link from '../../../Link/Link';
import CommonFormComponent from '../../../CommonField/CommonFormComponent';
import submit from "./submit";
import validate from './validate';
import { Button } from 'react-bootstrap';
import { normalizePromoCode } from '../../../EditProfileForm/normalizePhone';
import DatePicker from '../../../Common/DatePicker/DatePicker';
import moment from 'moment';
import { connect, useSelector } from 'react-redux';
import ToolTipSection from '../../../Common/ToolTipSection/ToolTipSection';
import { GoBackArrow } from '../../../Common/Assets/SvgIconComponent/CommonSvgIcon';
import FieldArrayComponent from '../../../CommonFields/FieldArrayComponent';
import { formatLocaleData } from '../../../../helpers/formatLocale';
import withStyles from 'isomorphic-style-loader/withStyles';
import messages from '../../../../locale/jsonMessages';
import cs from '../../../../components/commonStyle.css';

function PromoCodeForm(props) {
	const { title, handleSubmit, selectedLanguage, initialValues } = props
	const intl = useIntl();
	const selector = formValueSelector('PromoCodeForm');
	const expiryDate = useSelector(state => selector(state, 'expiryDate'));

	return (
		<div className='siteAdminCenterContainer'>
			<div className={cx('singleBtnFlexEnd', cs.spaceBottom4)}>
				<Link to="/siteadmin/promo-code" className='goBackLink'>
					<GoBackArrow />
					<FormattedMessage {...messages.goBack} />
				</Link>
			</div>
			<div className="siteAdminCenterContainerBox">
				<form onSubmit={handleSubmit(submit)}>
					<h1 className='siteAdminHeading'>{initialValues?.id ? intl.formatMessage(messages.editCouponCode) : intl.formatMessage(messages.addCouponCode)}</h1>
					<div className="oneColumnGrid">
						<div className={cx(cs.commonInputGrpDivider, 'twoColumnGrid')}>
							<Field
								name="code"
								component={CommonFormComponent}
								labelText={intl.formatMessage(messages.code)}
								placeholder={intl.formatMessage(messages.code)}
								parse={normalizePromoCode}
								toolTipText={intl.formatMessage(messages.promoCodeToolTip)}
								inputClass='commonInputField'
								isRequiredInput
							/>
							<Field
								name="promoValue"
								component={CommonFormComponent}
								labelText={intl.formatMessage(messages.tabDiscount)}
								placeholder={intl.formatMessage(messages.tabDiscount)}
								isAddon
								prefixLabel={`%`}
								toolTipText={intl.formatMessage(messages.promoDiscountToolTip)}
								maxLength={5}
								isRequiredInput
							/>
							<div>
								<label className='commonLabelText'>
									{intl.formatMessage(messages.expiryDate)}
									<ToolTipSection label={intl.formatMessage(messages.promoExpiryDateToolTip)} />
								</label>
								<DatePicker
									placeholder={intl.formatMessage(messages.expiryDate)}
									formName={'PromoCodeForm'}
									fieldName={'expiryDate'}
									initialDate={expiryDate ? moment(Number(expiryDate)).format('YYYY-MM-DD') : null}
									block={true}
									showClearDate={true}
									containerClassName="adminSingleDatePickerContainer"
								/>
							</div>
							<div>
								<div className='commonLabelText'>
									<FormattedMessage  {...messages.deductionType} />
									<ToolTipSection label={intl.formatMessage(messages.promoDeductionTypeToolTip)} />
								</div>
								<div className='customRatioButton commonRadioBtnFlexGroup'>
									{
										[
											{ value: "host", label: intl.formatMessage(messages.ownerLabel) },
											{ value: "admin", label: intl.formatMessage(messages.adminOption) }

										].map((item) => (
											<label className='commonRadioFlex'>
												<Field
													name="deductionType"
													component="input"
													type="radio"
													value={item.value}
												/>
												<span className='siteAdminRadioText'>{item.label}</span>
											</label>
										)

										)
									}
								</div>
							</div>
						</div>
						<FieldArray
							name="dynamicPromoCode"
							component={FieldArrayComponent}
							activesFields={['language', 'title', 'description']}
							filedName="dynamicPromoCode"
							selectedLanguage={selectedLanguage}
							fieldConfigs={{
								title: {
									label: intl.formatMessage(messages.titleLabel),
									placeholder: intl.formatMessage(messages.titleLabel),
									toolTipText: intl.formatMessage(messages.promoTitleToolTip),
								},
								description: {
									label: intl.formatMessage(messages.descriptionAdminLabel),
									placeholder: intl.formatMessage(messages.descriptionAdminLabel),
									toolTipText: intl.formatMessage(messages.promoDescriptionToolTip),
								},
							}}
						/>
					</div>
					<div className={cx('singleBtnFlexEnd', cs.spaceTop3)}>
						<Button type="submit" className={cs.btnPrimary}>
							{intl.formatMessage(messages.save)}
						</Button>
					</div>
				</form>
			</div>
		</div>
	)
}

const mapState = (state) => ({
	selectedLanguage: formValueSelector('PromoCodeForm')(state, 'dynamicPromoCode'),
	activeLanguageCodes: state.runtime.isActiveLanguages.map(item => formatLocaleData(item))
});

export default compose(
	withStyles(cs),
	connect(mapState),
	reduxForm({ form: 'PromoCodeForm', validate }),
	injectIntl,
)(PromoCodeForm);
